// extracted by mini-css-extract-plugin
export var buttonContainer = "_71-1";
export var fontSizeSelect = "_71-3";
export var formatSelect = "_71-2";
export var formats = "_71-4";
export var hidden = "_71-5";
export var icon = "_71-6";
export var select = "_71-0";